/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DeniedRolesAndUserGroups {
    getFixupPrototypeFunction() { return DeniedRolesAndUserGroups.fixupPrototype; }

    static newInstance(model: Partial<DeniedRolesAndUserGroups>): DeniedRolesAndUserGroups {
        let obj = Object.assign(new DeniedRolesAndUserGroups(), model);
        DeniedRolesAndUserGroups.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DeniedRolesAndUserGroups>): DeniedRolesAndUserGroups {
        if (!model) return null;
        return DeniedRolesAndUserGroups.newInstance(<DeniedRolesAndUserGroups> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DeniedRolesAndUserGroups) {
        if (!obj) return;

        models.DeniedRolesAndUserGroups.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DeniedRolesAndUserGroups): boolean {
        Object.setPrototypeOf(obj, DeniedRolesAndUserGroups.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Role IDs explicitly denied access
     */
    role_ids: Array<string>;

    /**
     * User groups explicitly denied access
     */
    user_group_ids: Array<string>;

}
